import { Component, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContactService } from '../../public/services/ContactService';
import { SubscribeRequest } from '../../requests/SubscribeRequest';
import { BaseResponse } from '../../responses/BaseResponse';
import { AlertService } from '../../public/services/alert-service';
import { Status } from '../../utilities/Status';

@Component({
  selector: 'app-subscribe',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './subscribe.component.html',
  styleUrl: './subscribe.component.css',
})
export class SubscribeComponent {
  subscribeForm!: FormGroup;
  isFormSubmitted = false;
  isLoad = false;

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly fb: FormBuilder,
    private readonly contactService: ContactService,
    private readonly alertService: AlertService
  ) {}

  ngOnInit() {
    this.subscribeForm = this.fb.group({
      emailAddress: ['', [Validators.required, Validators.email]]
    });
  }

  private resetSubscribeFormState() {
    this.subscribeForm.reset();
    this.subscribeForm.markAsPristine();
    this.subscribeForm.markAsUntouched();
    this.isFormSubmitted = false;
  }

  isFieldValid(field: string) {
    return (
      (!this.subscribeForm.get(field)!.valid && this.subscribeForm.get(field)!.touched) ||
      (this.subscribeForm.get(field)!.untouched && this.isFormSubmitted)
    );
  }

  onSubmit() {
    this.isFormSubmitted = true;
    if (this.subscribeForm.invalid) {
      this.subscribeForm.markAllAsTouched();
      return;
    }

    this.isLoad = true;
    const subscribeRequest: SubscribeRequest = {
      EmailAddress: this.subscribeForm.controls['emailAddress'].value,
      Website: 'SVDPGC'
    };

    this.contactService
      .subscribeEmail(subscribeRequest)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: BaseResponse) => {
          if (response.Status === Status.Yes) {
            this.alertService.showSuccess(response.Message, 'Subscribe');
            this.resetSubscribeFormState();
          } else {
            this.alertService.showError(response.Message, 'Subscribe');
          }
          this.isLoad = false;
        },
        error: (error:any) => {
          const errorMessage = error?.error?.message || error?.message || 'Unable to subscribe. Please try again.';
          this.alertService.showError(errorMessage, 'Subscribe');
          this.isLoad = false;
        }
      });
  }

}
